import React from "react";
import * as XLSX from "xlsx";

const HEADERS = [
  "slNo",
  "vendorName",
  "mobileNr",
  "email",
  "gender",
  "addressLine1",
  "addressLine2",
  "city",
  "state",
  "country",
  "postalCode",
  "vendorCategory",
  "companyCode",
  "joiningDate",
  "contactPersonCount",
  "jobTitle",
  "contactTitle",
  "contactPersonName",
  "contactPersonMobile",
  "contactPersonEmail",
  "bankInfoCount",
  "bankIFSC",
  "bankAccountNumber",
  "bankName",
  "branchAddress",
  "beneficiaryName",
  "preferredCurrency",
  "documentType",
  "documentNumber",
  "issueDate",
];

const SAMPLE = {
  slNo: 1,
  "vendorName": "SUMIT",
  "mobileNr": "9811183064",
  "email": "enquiry@medikart.co.in",
  gender: "Male",
  "addressLine1": "PRINTVISION",
  addressLine2: "20/47,West Patel Nagar",
  "city": "delhi",
  "state": "Karnataka",
  "country": "India",
  "postalCode": "110008",
  "vendorCategory": "Vendor",
  "companyCode": "NR - Norma",
  joiningDate: "31-12-2025",
  contactPersonCount: 1,
  jobTitle: "105 - Project Manager",
  contactTitle: "Mr.",
  "contactPersonName": "SUMIT",
  "contactPersonMobile": "9811183064",
  "contactPersonEmail": "sumit@medikart.co.in",
  bankInfoCount: 1,
  bankIFSC: "PUNB0405200",
  bankAccountNumber: "1234567895",
  bankName: "Punjab National Bank",
  branchAddress: "Indirapuram",
  beneficiaryName: "SUMIT",
  preferredCurrency: "INR",
  documentType: "101 - GST Registration",
  documentNumber: "07AAEPAO339EIZF",
  issueDate: "31-12-2025",
};

const DownloadVendorTemplateMR = ({ fileName = "Vendor_Bulk_Upload_Template.xlsx" }) => {
  const downloadTemplate = () => {
    // Make an empty sheet then add header row (ensures order)
    const ws = XLSX.utils.aoa_to_sheet([HEADERS]);
    // Add sample row starting from row 2
    XLSX.utils.sheet_add_json(ws, [SAMPLE], { origin: "A2", skipHeader: true });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");

    XLSX.writeFile(wb, fileName);
  };

  return (
    <button className="btnTable" type="button" onClick={downloadTemplate}>
      <i className="bi bi-download px-2"></i>
      Download File
    </button>
  );
};

export default DownloadVendorTemplateMR;
